<div class="centralizer">
    <div class="header-container">
        <div class="home-btn">
            <img src="assets/logos/group2.svg">
            <span>
                <app-dropdown-waiting-room (fowardToOtherPage)="selecPatient(null, true)"></app-dropdown-waiting-room>
            </span>
        </div>
        <div class="actions-container">
            <div class="input-container">
                <app-search-input></app-search-input>
            </div>
            <app-dropdown [name]="userInitials"></app-dropdown>
        </div>
        <div (click)="resetSearch()" class="background" *ngIf="backgroundOn"></div>
    </div>
</div>
